/* eslint-disable no-shadow */
import React, { FC, Dispatch, SetStateAction, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { LANDING } from '../../../constants/routes'
import { Button } from '../../../components/Button'
import { BackButton } from '../../../components/BackButton'
import { SignUpStep } from '../index'

import { Wrap, InnerWrap } from './styled'

type ToolbarProps = {
  disabledButton: boolean
  onClick: () => void
  step: SignUpStep
  setStep: Dispatch<SetStateAction<SignUpStep>>
}

const ToolBar: FC<ToolbarProps> = ({
  disabledButton,
  onClick,
  step,
  setStep,
}) => {
  const historyHook = useHistory()

  const handleClick = useCallback(() => {
    if (step === SignUpStep.ABOUT_ME) {
      setStep(SignUpStep.PROFILE_SET)
    }
    if (step === SignUpStep.PHOTO) {
      setStep(SignUpStep.ABOUT_ME)
    }
    if (step === SignUpStep.PROFILE_SET) {
      historyHook.push(LANDING)
    }
  }, [step, setStep, historyHook])

  return (
    <Wrap>
      <InnerWrap>
        <BackButton
          type="button"
          label="Back"
          disabled={false}
          onClick={handleClick}
        />
        <Button
          type="button"
          label="Continue"
          disabled={disabledButton}
          onClick={onClick}
        />
      </InnerWrap>
    </Wrap>
  )
}

export default ToolBar
